import { PaletteMode } from '@mui/material';
import { StateCreator } from 'zustand';
import { GlobalState } from './types';

// Exported here instead of Navbar component to avoid circular dependency.
export const DEFAULT_NAVBAR_WIDTH_PX = 320;

export interface SettingsState {
  selectedPartnerId: number | null;
  setSelectedPartnerId: (id: number | null) => void;
  isMultiTenancyMode: boolean;
  setMultiTenancyMode: (isMultiTenancyMode: boolean) => void;
  navbar: {
    isOpen: boolean;
    width: number;
  };
  setNavbar: (navbar: Partial<SettingsState['navbar']>) => void;
  forceThemeMode: PaletteMode | null;
  setForceThemeMode: (mode: PaletteMode | null) => void;
  activityFeed: {
    conversations: boolean;
  };
  toggleConversationsActivityFeed: () => void;
}

export const createSettingsSlice: StateCreator<GlobalState, [], [], SettingsState> = (
  set,
) => ({
  forceThemeMode: null,
  selectedPartnerId: null,
  setSelectedPartnerId: (id) => set({ selectedPartnerId: id }),
  isMultiTenancyMode: false,
  setMultiTenancyMode: (isMultiTenancyMode) => set({ isMultiTenancyMode }),
  navbar: {
    isOpen: true,
    width: DEFAULT_NAVBAR_WIDTH_PX,
  },
  setNavbar: (navbar) => set((state) => ({ navbar: { ...state.navbar, ...navbar } })),
  setForceThemeMode: (forceThemeMode) => set({ forceThemeMode }),
  activityFeed: {
    conversations: false,
  },
  toggleConversationsActivityFeed: () =>
    set((state) => ({ activityFeed: { conversations: !state.activityFeed.conversations } })),
});
